import {
  WalletRechargeResponse,
  WalletRechargesPageResponse,
} from "../../../domain/models/integration/wallet-recharges.model";

type UnknownRecord = Record<string, unknown>;
const isRecord = (value: unknown): value is UnknownRecord =>
  typeof value === "object" && value !== null && !Array.isArray(value);
const isNumber = (value: unknown): value is number =>
  typeof value === "number" && Number.isFinite(value);
const isNullableNumber = (value: unknown): value is number | null =>
  value === null || isNumber(value);
const isNullableString = (value: unknown): value is string | null =>
  value === null || typeof value === "string";
const isOptionalNullableString = (value: unknown): value is string | null | undefined =>
  value === undefined || isNullableString(value);

const isWalletRecharge = (value: unknown): value is WalletRechargeResponse =>
  isRecord(value) &&
  isNumber(value["rechargeId"]) &&
  isNullableString(value["operationCode"]) &&
  isNullableString(value["username"]) &&
  isNullableString(value["memberFullName"]) &&
  isNullableString(value["project"]) &&
  isNullableString(value["portfolio"]) &&
  isNullableString(value["membershipType"]) &&
  isNullableNumber(value["amount"]) &&
  isNullableString(value["currency"]) &&
  isNullableString(value["paymentType"]) &&
  isNullableString(value["operationDate"]) &&
  isOptionalNullableString(value["confirmationDate"]) &&
  isNullableString(value["macroCode"]) &&
  isNullableString(value["macroOperationCode"]) &&
  isNullableString(value["validationStatus"]);

export function isWalletRechargesPageResponse(
  value: unknown,
): value is WalletRechargesPageResponse {
  return isRecord(value) &&
    Array.isArray(value["content"]) &&
    value["content"].every(isWalletRecharge) &&
    isNumber(value["page"]) &&
    isNumber(value["size"]) &&
    isNumber(value["totalElements"]) &&
    isNumber(value["totalPages"]);
}

export function isStringList(value: unknown): value is readonly string[] {
  return Array.isArray(value) && value.every((item) => typeof item === "string");
}
